<div *ngIf="isReactive" class="itb-divider-checkbox" [formGroup]="parentForm">
  <mat-checkbox
    [labelPosition]="position"
    [formControlName]="formFieldName"
    [checked]="isChecked"
    (change)="changeEvent($event)"
  >
    {{ label }}
  </mat-checkbox>
  <itb-divider [className]="'mat-divider'"></itb-divider>
</div>

<div *ngIf="!isReactive" class="itb-divider-checkbox">
  <mat-checkbox
    [labelPosition]="position"
    [checked]="isChecked"
    [disabled]="isDisabled"
    (change)="changeEvent($event)"
  >
    {{ label }}
  </mat-checkbox>
  <itb-divider [className]="'mat-divider'"></itb-divider>
</div>
